import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';

import { formatChallengeStartDate } from '../../utils/challengePropagation';
import ConfirmDialog from '../ConfirmDialog';

import texts from './texts.json';

/**
 * Tells the coach that saving a template will update the clients already signed
 * up for a challenge that has not started. Shown while `propagation` is set.
 *
 * `content` is a template with `{challengeName}` and `{startDate}` placeholders,
 * worded by the editor for what it saves (a program's workouts, a meal plan).
 */
const ChallengePropagationDialog = ({
  propagation,
  title,
  content,
  onConfirm,
  onCancel,
}) => {
  if (!propagation) {
    return null;
  }

  return (
    <ConfirmDialog
      isOpen
      onConfirm={onConfirm}
      onCancel={onCancel}
      dialogTexts={{
        title,
        content: format(content, {
          challengeName: propagation.challengeName || texts.unnamedChallenge,
          startDate: formatChallengeStartDate(propagation.startDate),
        }),
        confirm: texts.confirm,
        cancel: texts.cancel,
      }}
    />
  );
};

ChallengePropagationDialog.propTypes = {
  propagation: PropTypes.shape({
    challengeName: PropTypes.string,
    startDate: PropTypes.string,
  }),
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

ChallengePropagationDialog.defaultProps = {
  propagation: null,
};

export default ChallengePropagationDialog;
